import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import productList from 'src/app/Models/Product/product_model';
import { ProductComponent } from '../product/product.component';

@Component({
  selector: 'app-layout-products',
  templateUrl: './layout-products.component.html',
  styleUrls: ['./layout-products.component.scss'],
  standalone: true,
  imports: [
    CommonModule
    , ProductComponent
  ]
})
export class LayoutProductsComponent implements OnChanges{
  isLoading = true;
  @Input() Props?: Props;
  @Input() Products?: productList[]
  @Input() appearance: 'default' | 'home' = 'default';

  trackBy(index: number, items: any){
    return items.code;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.Products){
      this.isLoading = !changes.Products.currentValue;
    }
  }
}

interface Props{
  [key: string]: any;
  styles: { [key: string]: any };
}
